export default __webpack_public_path__ + "images/d2ff5d5e625ad96c0b9e083c2f39910c.svg";